export const toggleValue = (currentValues: string[], newValue: string) => {
  if (currentValues.includes(newValue)) {
    return currentValues.filter((v) => v !== newValue);
  }
  return [...currentValues, newValue];
};
